import { genericAtom } from './jotai';

export interface BranchNotify {
    readonly branchId?: string;
    readonly badge: number;

}

export const branchNotificationState = genericAtom<BranchNotify | null>(null);


